export default "__VITE_ASSET__6d813888__"